<script>
import {computed} from "vue";

export default {
    props: {
        text: String,
        bold: Boolean,
        disableInline: Boolean,
        clazz: String,
        // Add this to toggle the "ink link" behavior
        clickable: {
            type: Boolean,
            default: false
        },
        icon: String,
        iconColor: String,
        length: {
            type: Number,
            default: null
        },
    },
    emits: ["press"],
    setup(props, {emit}) {
        function press() {
            if (props.clickable) {
                emit('press');
            }
        }
        
       const isTruncated = computed(() =>
            props.length != null && !!props.text && props.text.length > props.length
        );

        const displayText = computed(() =>
            isTruncated.value ? props.text.slice(0, props.length) + '...' : props.text
        );

        return {
            press,
            isTruncated,
            displayText
        }
    }
}

</script>

<template>
    <component
        :is="bold ? 'strong' : 'span'"
        :class="[clazz, { 'ink-link': clickable }]"
        :style="!disableInline ? 'white-space: nowrap;' : ''"
        @click="press"
    >
        <w-tooltip
            :label="displayText"
            :tooltip="isTruncated ? text : null"
        />
        <v-icon small :color="iconColor" v-if="icon">{{ icon }}</v-icon>
    </component>
</template>

<style scoped>
/* Base ink style for all instances */
.ink-link {
    cursor: pointer;
    position: relative;
    transition: color 0.3s ease;
    color: #0d5eb0;
}

/* Underline only appears for clickable components */
.ink-link::after {
    content: '';
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    height: 1.2px;
    background-color: currentColor;
    opacity: 0.4;
    /* Hand-drawn look */
    border-radius: 40% 60% 30% 70% / 50%;
    transition: opacity 0.3s, transform 0.3s;
}

/* Hover effects only for clickable components */
.ink-link:hover {
    color: #000;
    text-shadow: 0.5px 0.5px 1px rgba(0, 0, 0, 0.2);
}

.ink-link:hover::after {
    opacity: 0.8;
    transform: scaleX(1.05);
}
</style>